import { z } from 'zod';

const UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
// カンマ区切りの UUID:<数値>
// オプションのIDと数を把握するための形式
const OPS_PATTERN = new RegExp(`^$|^(${UUID_PATTERN}:\\d+)(,${UUID_PATTERN}:\\d+)*$`, 'i');
// 数値のみ、またはゲストタイプ情報を含む形式（UUID:数値,UUID:数値...）
const PPL_PATTERN = new RegExp(`^\\d+$|^(${UUID_PATTERN}:\\d+)(,${UUID_PATTERN}:\\d+)*$`, 'i');

export const ReservationQueryParamsSchema = z.object({
  expEvt: z.string().uuid(),
  // nullableをつけると、opsのクエリパラメータに=がついていない場合にも対応できる
  // 例 /reserve/?expEvt=123&ops&int=123&ppl=1
  ops: z.string().regex(OPS_PATTERN).optional().nullable(),
  int: z.string().uuid().optional().nullable(),
  // 数値のみ、またはゲストタイプ情報を含む形式（UUID:数値,UUID:数値...）
  ppl: z.string().regex(PPL_PATTERN),
});

export type ReservationQueryParams = z.infer<typeof ReservationQueryParamsSchema>;
